import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import user from './user'
import getters from "./getters";

Vue.use(Vuex)


export default new Vuex.Store({
  plugins: [createPersistedState()], // 默认的就是 LocalStorage存储
  modules: {
    user
  },
  getters
})



// WEBPACK FOOTER //
// ./src/store/index.js